import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import store from "./app/store";
import { Provider } from "react-redux";
import { injectStore } from "./common/setupApi";
import Theme from "./common/theme/Theme";
import { BrowserRouter } from "react-router-dom";
import ServiceWorkerProvider from "./features/appUpdate/ServiceWorkerProvider";
import "./index.css";
import "@stripe/stripe-js";
injectStore(store);

const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Theme>
      <BrowserRouter>
        <ServiceWorkerProvider>
          <App />
        </ServiceWorkerProvider>
      </BrowserRouter>
    </Theme>
  </Provider>
  // </React.StrictMode>
);
